/* unplugin-vue-components disabled */import { render } from "./DeviceIdfa.vue?vue&type=template&id=751dc3e7&scoped=true"
import script from "./DeviceIdfa.vue?vue&type=script&lang=js"
export * from "./DeviceIdfa.vue?vue&type=script&lang=js"

import "./DeviceIdfa.vue?vue&type=style&index=0&id=751dc3e7&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751dc3e7"]])

export default __exports__